import http from "@/utils/http";
export async function getAataIntegration(): Promise<any> {
  const query = `  
{
  workbench_data_integration{
    compose{
      total_composed
      month_composed
    }
    publish{
      published
      month_published
    }
    benefits{
      benefit_type
      benefit_value
    }
    collection{
      script_num
      session_num
      job_num
    }
  }
}
`;

  try {
    const res = await http.post(`/api/v1/graphql/`, {
      query,
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function wechatQrcode(): Promise<any> {
  try {
    const res = await http.get("/api/v1/user/wechat_qrcode");
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getHotTags(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/video/screen/hot_word", { params });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getContacts(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/video/auth/smart_strategy/team/business", {
      params,
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

// 下载标签排名
export async function exportExcelApi(data: any) {
  return http(`/api/v1/video/task/export`, {
    method: 'POST',
    data,
    responseType: 'blob',
  });
}

// 下载询盘排名
export async function exportExcelContentApi(data: any) {
  return http(`/api/v1/video/task/business`, {
    method: 'POST',
    data,
    responseType: 'blob',
  });
}